module.exports = __webpack_public_path__ + "static/media/s_v5_t3.4f34047c.mp3";